export default __webpack_public_path__ + "static/media/map.c96757bb.jpg";